import http from "../HttpService";

const controller = "/otherpage/";

function getUrlItem(tenantId, id) {
  return `${controller}${tenantId}/${id}`;
}

function getUrl(tenantId) {
  return `${controller}${tenantId}`;
}

function getUrlAll(tenantId) {
  return `${controller}all/${tenantId}`;
}

export function getData(tenantId) {
  return http.get(getUrlAll(tenantId));
}

export function getItem(tenantId, id) {
  return http.get(getUrlItem(tenantId, id));
}

export function deleteData(tenantId, id) {
  return http.delete(getUrlItem(tenantId, id));
}

export function save(item) {
  let id = item.get("id");

  const config = {
    headers: {
      "content-type": "multipart/form-data",
    },
  };
  if (parseInt(id) > 0) {
    console.log("save other page put ", item);
    return http.put(getUrl(id), item, config);
  } else {
    console.log("save other page post ", item);
    return http.post(controller, item, config);
  }
}

/*import * as Helper from "../../_Helper";

const data = [
  {
    id: 1,
    tenantId: 6,
    menu: {
      id: 999,
      order: 1,
      icon: "fa-user",
      name: "Preventivní prohlídky",
      link: "preventivni-prohlidky",
    },
    title: "Preventivní prohlídka",
    text:
      "<p>V 18 letech, resp. nejpozději při dovr&scaron;en&iacute; 19 let se mus&iacute; každ&yacute; zaregistrovat u praktick&eacute;ho l&eacute;kaře pro dospěl&eacute;. VZP plně hrad&iacute;&nbsp;<strong>preventivn&iacute; prohl&iacute;dku u praktick&eacute;ho l&eacute;kaře jednou za 2 roky</strong>&nbsp;(po uplynut&iacute; 23 měs&iacute;ců). Měl by ji absolvovat každ&yacute; člověk, i když nem&aacute; vůbec ž&aacute;dn&eacute; zdravotn&iacute; probl&eacute;my. Nezapomeňte se na preventivn&iacute; prohl&iacute;dku&nbsp;<strong>předem objednat</strong>, aby v&aacute;m l&eacute;kař mohl př&iacute;padně d&aacute;t ž&aacute;danku k odběru krve nebo pro dal&scaron;&iacute; stanoven&aacute; vy&scaron;etřen&iacute;. Přin&eacute;st budete muset vzorek moči.</p>      <p>Preventivn&iacute; prohl&iacute;dka je celkov&yacute;m vy&scaron;etřen&iacute;m a jej&iacute; souč&aacute;st&iacute; je vždy&nbsp;<strong>doplněn&iacute; pacientovy namn&eacute;zy</strong>. U rodinn&eacute; anamn&eacute;zy je zvl&aacute;&scaron;tn&iacute; důraz kladen na v&yacute;skyt kardiovaskul&aacute;rn&iacute;ch, plicn&iacute;ch a n&aacute;dorov&yacute;ch onemocněn&iacute;, poruchy metabolizmu tuků, hypertenze či diabetu.</p>      <p>L&eacute;kař v&aacute;m provede&nbsp;strong>kompletn&iacute; fyzik&aacute;ln&iacute; vy&scaron;etřen&iacute;</strong>&nbsp;(poklepem a poslechem vy&scaron;etř&iacute; srdce a pl&iacute;ce, pohmatem &scaron;t&iacute;tnou žl&aacute;zu, zkontroluje stav žil a tepen na doln&iacute;ch končetin&aacute;ch atd.), změř&iacute; krevn&iacute; tlak a zjist&iacute; index tělesn&eacute; hmotnosti (BMI). M&aacute; tak&eacute; orientačně vy&scaron;etřit zrak a sluch a zkontrolovat očkov&aacute;n&iacute;, mj. proti tetanu. Vždy je souč&aacute;st&iacute; preventivn&iacute; prohl&iacute;dky vy&scaron;etřen&iacute; moči diagnostick&yacute;m pap&iacute;rkem.</p>      <p>Souč&aacute;st&iacute; prohl&iacute;dky je v r&aacute;mci onkologick&eacute; prevence&nbsp;<strong>zhodnocen&iacute; rizik</strong>&nbsp;z hlediska rodinn&eacute;, pracovn&iacute; i osobn&iacute; anamn&eacute;zy. D&aacute;le se děl&aacute; vy&scaron;etřen&iacute; kůže, u zji&scaron;těn&eacute;ho podezřen&iacute; na riziko tak&eacute; vy&scaron;etřen&iacute; per rectum (konečn&iacute;kem). U mužů se při pozitivn&iacute; rodinn&eacute; anamn&eacute;ze prov&aacute;d&iacute; klinick&eacute; vy&scaron;etřen&iacute; varlat. Žen&aacute;m od 25 let, kter&eacute; maj&iacute; v rodině v&yacute;skyt zhoubn&eacute;ho n&acute;doru prsu nebo maj&iacute; jin&eacute; rizikov&eacute; faktory, m&aacute; l&eacute;kař prov&eacute;st klinick&eacute; vy&scaron;etřen&iacute; prsů a poučit je o samovy&scaron;etřov&aacute;n&iacute;.</p>      <p>Souč&aacute;st&iacute; preventivn&iacute; prohl&iacute;dky je t&eacute;ž&nbsp;<strong>kontrola a zhodnocen&iacute; v&yacute;sledků předepsan&yacute;ch preventivn&iacute;ch vy&scaron;etřen&iacute;</strong>&nbsp;(resp. jejich zaji&scaron;těn&iacute;, pokud nebyly v předepsan&yacute;ch term&iacute;nech provedeny). Jedn&aacute; se zejm&eacute;na o vy&scaron;etřen&iacute; EKG, laboratorn&iacute; vy&scaron;etřen&acute; koncentrace cholesterolu a triacylglycerolů v krvi a laboratorn&iacute; vy&scaron;etřen&iacute; glyk&eacute;mie. Věk, kdy se pacientovi kter&aacute; vy&scaron;etřen&iacute; prov&aacute;děj&iacute;, najdete v na&scaron;em&nbsp;<a href='https://www.vzp.cz/pojistenci/prevence/reventivni-prohlidky'>harmonogramu p&eacute;če</a>&nbsp;pro jednotliv&eacute; věkov&eacute; skupiny.</p>      <p>Praktick&yacute; l&eacute;kař se star&aacute; i o&nbsp;<strong>screeningov&aacute; vy&scaron;etřen&iacute;</strong>&nbsp;pro prevenci rakoviny. Žen&aacute;m m&aacute; předat doporučen&iacute; k proveden&iacute; mamografie (od 45 let 1x za 2 roky) a žen&aacute;m i mužům m&aacute; zajistit screening karcinomu tlust&eacute;ho střeva a konečn&iacute;ku (stanoven&iacute; okultn&iacute;ho krv&aacute;cen&iacute; ve stolici speci&aacute;ln&iacute;m testem 1x za rok od 50 let, n&aacute;sledně od 55 let 1x za 2 roky, nebo screeningov&aacute; kolonoskopie jednou za 10 let). Tat&aacute;ž vy&scaron;etřen&iacute; ale může žen&aacute;m prov&eacute;st, resp. d&aacute;t jim na ně doporučen&iacute; i gynekolog, a proto je praktick&yacute; l&eacute;kař nezaji&scaron;ťuje, pokud m&aacute; k dispozici v&yacute;sledky.</p>",
    imageSrc: "https://picsum.photos/id/250/250/250",
  },
];

export function getData(tenantId) {
  return data.filter((m) => m.tenantId === tenantId).sort((a, b) => b.id - a.id);
}

export function deleteData(id) {
  let item = data.find((m) => m.id === id);
  data.splice(data.indexOf(item), 1);
  return item;
}

export function getItem(id) {
  return data.find((m) => m.id === id);
}

export function save(item) {
  let itemInDb = data.find((m) => m.id === item.id) || {};
  //update
  if (itemInDb.id > 0) {
    deleteData(item.id);
    itemInDb = item;
  } else {
    //insert
    itemInDb = item;
    itemInDb.id = Helper.createId();
  }

  data.push(itemInDb);

  return itemInDb;
}
*/
